import { createContext } from 'react';
import { noop } from 'src/helpers/noop';
import { SetStateAction, Dispatch } from 'react';

export interface EmailChange {
  firstEmail: string;
  firstStudentNumber: string;
  secondEmail: string;
  secondStudentNumber: string;
}

export const initialEmailChangeState = {
  firstEmail: '',
  firstStudentNumber: '',
  secondEmail: '',
  secondStudentNumber: '',
};

export interface AdminState {
  refetchUser: () => void;
  refetchEnrollment: () => void;
  setIsImpersonating: Dispatch<SetStateAction<boolean>>;
  setEmailChange: Dispatch<SetStateAction<EmailChange>>;
  setReason: Dispatch<SetStateAction<string>>;
  setStudentNumber: Dispatch<SetStateAction<string>>;
  emailChange: EmailChange;
  studentNumber: string;
  reason: string;
  isImpersonating: boolean;
}

const AdminContext = createContext<AdminState>({
  setIsImpersonating: noop,
  setEmailChange: noop,
  setStudentNumber: noop,
  setReason: noop,
  refetchUser: noop,
  refetchEnrollment: noop,
  emailChange: initialEmailChangeState,
  reason: '',
  isImpersonating: false,
  studentNumber: '',
});

export default AdminContext;
